import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Icon,
  VStack,
  Text,
  Box,
} from "@chakra-ui/react";
import { TbFileTypePpt } from "react-icons/tb";
import { FaChevronDown } from "react-icons/fa";
import GlobalEntity from "../GlobalEntity";
import { Header } from "build-ts/metadata";
import { DateFilter } from "build-ts/relative_date";
import { DateFilterCategory } from "utils/enum";

interface RunJobModalProps {
  isOpen: boolean;
  onClose: () => void;
  reports: Header[];
  selectedReport: Header | null;
  handleReportHeaderSelect: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  reportError: string | null;
  dateError: string | null;
  updateContextInJobSteps: () => void;
  dateFilter: DateFilter | undefined;
  dateFilterCategory: DateFilterCategory | undefined;
  setDateFilter: React.Dispatch<React.SetStateAction<DateFilter | undefined>>;
  setDateFilterCategory: React.Dispatch<React.SetStateAction<DateFilterCategory>>;
}

const RunJobModal: React.FC<RunJobModalProps> = ({
  isOpen,
  onClose,
  reports,
  selectedReport,
  handleReportHeaderSelect,
  reportError,
  dateError,
  updateContextInJobSteps,
  dateFilter,
  dateFilterCategory,
  setDateFilter,
  setDateFilterCategory,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    size="lg"
    isCentered
  >
    <ModalOverlay />
    <ModalContent>
      <ModalHeader p={4}>Run Job</ModalHeader>
      <ModalCloseButton />
      <ModalBody p={4}>
        <VStack spacing={1} align="stretch">
          {/* Select Report Section */}
          <FormControl id="range-type" isRequired>
            <FormLabel fontWeight="bold">
              Select Report
              <Icon as={TbFileTypePpt} boxSize={4} ml={1} />
            </FormLabel>
            <Menu>
              <MenuButton
                as={Button}
                w="100%"
                variant="outline"
                colorScheme="gray"
                rightIcon={<Icon as={FaChevronDown} boxSize={3} />} // Dropdown arrow icon
                size="xs"
                bg="white"
                fontWeight={600}
                fontSize="xs"
                _hover={{ bg: "purple.50" }}
                textAlign="left"
                color="gray.600"
              >
                {selectedReport?.name || "Select Report"}
              </MenuButton>
              <MenuList maxH="300px" overflowY="auto">
                {reports?.map((story) => (
                  <MenuItem
                    key={story.id}
                    onClick={() =>
                      handleReportHeaderSelect({
                        target: { value: story.id },
                      } as React.ChangeEvent<HTMLSelectElement>)
                    }
                  >
                    <Text fontSize="sm" fontWeight="medium">
                      {story.name}
                    </Text>
                  </MenuItem>
                ))}
              </MenuList>
            </Menu>
          </FormControl>
          {reportError && (
            <Text color="red.500" fontSize="xs" mt={1}>
              {reportError}
            </Text>
          )}
          <Box>
            <GlobalEntity 
              setDateFilter={setDateFilter}
              setDateFilterCategory={setDateFilterCategory}
              dateFilter={dateFilter}
              dateFilterCategory={dateFilterCategory}
              id="runjob"
            />
            {dateError && (
              <Text color="red.500" fontSize="xs" mt={1}>
                {dateError}
              </Text>
            )}
          </Box>
        </VStack>
      </ModalBody>
      <ModalFooter>
        <Button colorScheme="purple" onClick={() => updateContextInJobSteps()}>
          Run
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export default RunJobModal;
